module.exports = ".modal-token-body th,\n.modal-token-body td {\n  width: calc(100% / 3);\n  padding-top: 8px; }\n\n.spinner {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/gto-token/resend-token/resend-token.component.scss
// module id = ./src/app/components/gto-token/resend-token/resend-token.component.scss
// module chunks = main